import { observable, runInAction } from 'mobx';
import axios from 'axios';

export class CopyTradingStore {
    constructor({ rootStore }) {
        this.rootStore = rootStore;
    }

    @observable signals = [];

    async createSignal(signal) {
        return await axios.post(`${this.rootStore.env.signalsApi}ingest`, signal, {
            headers: {
                Authorization: `Bearer ${this.rootStore.userStore.idToken}`,
                'apex-token': this.rootStore.userStore.currentUser.copy_trader_token
            }
        });
    }

    async getRecentSignals() {
        const { data } = await axios.get(
            `${this.rootStore.env.signalsApi}${this.rootStore.userStore.currentUser.copy_trader_provider_id}/recent`,
            {
                headers: {
                    Authorization: `Bearer ${this.rootStore.userStore.idToken}`,
                    'apex-token': this.rootStore.userStore.currentUser.copy_trader_token
                }
            }
        );

        runInAction(() => {
            this.signals = data.signals;
        });
    }
}



// WEBPACK FOOTER //
// ./src/stores/CopyTradingStore.js